module.exports = __webpack_public_path__ + "img/video-camera.9440fcd9.svg";